module.exports = __webpack_public_path__ + "img/Frame_02.de4ef928.png";